export const indexLayoutSidebar = 56
export const leftWidth = 232
export const rightWidth = 350
export const canvasFirstRightWidth = 300
